import { render, staticRenderFns } from "./chooseZodiac.vue?vue&type=template&id=b71615ba&scoped=true&"
import script from "./chooseZodiac.vue?vue&type=script&lang=ts&"
export * from "./chooseZodiac.vue?vue&type=script&lang=ts&"
import style0 from "./chooseZodiac.vue?vue&type=style&index=0&id=b71615ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b71615ba",
  null
  
)

export default component.exports